module.exports = __webpack_public_path__ + "media/vue/assets/images/booking-service/find-a-store-6fa74e3b24a637c8685fe91d5ab3729a.jpg";